import { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

const DiHorizontalScroll = ({ children, className = "" }) => {
  const scrollContainerRef = useRef(null);
  const [maskClass, setMaskClass] = useState("mask-start mask-end");

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const updateMask = () => {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
      let newClass = "";

      // Se possiamo scrollare verso sinistra, aggiungi la maschera a sinistra
      if (scrollLeft > 0) newClass += " mask-start";
      
      // Se possiamo scrollare a destra, aggiungi la maschera a destra
      // Aggiungi una tolleranza, per evitare problemi di larghezza eccessiva
      if (scrollLeft + clientWidth < scrollWidth - 1) newClass += " mask-end";

      setMaskClass(newClass.trim());
    };

    // Funzione per verificare se possiamo scrollare a destra o sinistra anche prima di fare scroll
    const checkInitialScroll = () => {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
      let newClass = "";

      // Verifica la possibilità di scrollare a sinistra
      if (scrollLeft > 0) newClass += " mask-start";
      
      // Verifica la possibilità di scrollare a destra
      if (scrollLeft + clientWidth < scrollWidth - 1) newClass += " mask-end";

      setMaskClass(newClass.trim());
    };

    // Eseguiamo subito la funzione di check iniziale per impostare le maschere
    checkInitialScroll();

    // Aggiorna la maschera mentre si scrolla
    scrollContainer.addEventListener("scroll", updateMask);

    return () => scrollContainer.removeEventListener("scroll", updateMask);
  }, []);

  return (
    <div
      ref={scrollContainerRef}
      className={`di-scroll-container x-scroll relative ${maskClass}`}
      style={{ WebkitOverflowScrolling: "touch" }}
    >
      {/* Wrapper per contenere gli elementi e forzare lo scroll */}
      <div className={`flex gap-4 min-w-max ${className}`}>{children}</div>
    </div>
  );
};

DiHorizontalScroll.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default DiHorizontalScroll;
